import { intelClient } from 'src/api/config';

function fetchLatestInsight(params) {
  return intelClient.get('/api/insights/downloads/latest', { params });
}

export default fetchLatestInsight;
